import axios from 'axios'
import { toastr } from 'react-redux-toastr'

import { URL } from '../../assets/js/constants'

export function carregarVenda(data) {
    return {
        type: 'VENDA_FETCHED',
        payload: data
    }
}

export function carregarVendas(data) {
    console.log('carregarVendas', data);
    return {
        type: 'VENDAS_FETCHED',
        payload: data
    }
}

export function vendaLoading(data) {
    return {
        type: 'VENDA_LOADING',
        payload: data
    }
}

export function getVenda(pedidoId) {
    return dispatch => {
        dispatch(vendaLoading(true));
        axios.get(`${URL}/pedidos/vendedor/MOBILE/${pedidoId}`)
            .then(resp => {
                dispatch(carregarVenda(resp.data));
                dispatch(vendaLoading(false));
            })
            .catch(e => {
                dispatch(vendaLoading(false));
                toastr.error('Erro', 'Encontramos problemas ao tentar trazer uma venda.' + e.message);
            })
    }
}

export function getVendas() {
    return dispatch => {
        dispatch(vendaLoading(true));
        axios.get(`${URL}/pedidos`)
            .then(resp => {
                dispatch(carregarVendas(resp.data));
                dispatch(vendaLoading(false));
            })
            .catch(e => {
                dispatch(vendaLoading(false));
                toastr.error('Erro', 'Encontramos problemas ao tentar trazer as vendas.' + e.message);
            })
    }
}

export function getVendasEmAndamento(idVendedor) {
    return dispatch => {
        dispatch(vendaLoading(true));
        axios.get(`${URL}/pedidos/em-andamento/vendedor/${idVendedor}`)
            .then(resp => {
                dispatch(carregarVendas(resp.data));
                dispatch(vendaLoading(false));
            })
            .catch(e => {
                dispatch(vendaLoading(false));
                toastr.error('Erro', 'Encontramos problemas ao tentar trazer suas vendas.' + e.message);
            })
    }
}

export function getVendasEntregues(idVendedor) {
    return dispatch => {
        dispatch(vendaLoading(true));
        axios.get(`${URL}/pedidos/entregues/vendedor/${idVendedor}`)
            .then(resp => {
                dispatch(carregarVendas(resp.data));
                dispatch(vendaLoading(false));
            })
            .catch(e => {
                dispatch(vendaLoading(false));
                toastr.error('Erro', 'Encontramos problemas ao tentar trazer suas vendas.' + e.message);
            })
    }
}

export function getVendasCanceladas(idVendedor) {
    return dispatch => {
        dispatch(vendaLoading(true));
        axios.get(`${URL}/pedidos/cancelados/vendedor/${idVendedor}`)
            .then(resp => {
                dispatch(carregarVendas(resp.data));
                dispatch(vendaLoading(false));
            })
            .catch(e => {
                dispatch(vendaLoading(false));
                toastr.error('Erro', 'Encontramos problemas ao tentar trazer suas vendas.' + e.message);
            })
    }
}

export function atualizarEstadoPedido(value) {
    return dispatch => {
        axios.put(`${URL}/pedidos/atualizar-estado-pedido`, value)
            .then(_ => dispatch(getVendasEmAndamento(value.idVendedor)))
            .then(_ => {
                toastr.success('Sucesso', 'Estado atualizado com sucesso.');
            })
            .catch(e => {
                toastr.error('Erro', 'Encontramos problemas ao tentar atualizar o estado do pedido.' + e.message);
            })
    }
}

export function registrarNotaFiscalDoPedido(data, pedidoId) {
    return dispatch => {
        axios.put(`${URL}/pedidos/${pedidoId}/registrar-nota`, data)
            .then(_ => dispatch(getVenda(pedidoId)))
            .then(_ => {
                toastr.success('Sucesso', 'NFe registrada com sucesso! Aguarde até que a etiqueta de envio seja disponibilizada.');
            })
            .catch(e => {
                toastr.error('Erro', 'Encontramos problemas ao tentar registrar a NFe do pedido.' + e.message);
            })
    }
}

export function registrarIsentoNotaFiscalDoPedido(pedidoId){
    return dispatch => {
        axios.put(`${URL}/pedidos/${pedidoId}/registrar-isencao-nota`)
            .then(_ => dispatch(getVenda(pedidoId)))
            .then(_ => {
                toastr.success('Sucesso', 'Informação registrada com sucesso!');
            })
            .catch(e => {
                toastr.error('Erro', 'Encontramos problemas ao tentar registrar a NFe do pedido.' + e.message);
            })
    }
}